import {fromJS} from 'immutable';

export const DEFAULT_STATE = fromJS({
    isLoggedIn: false,
    loading: false,
    accountInfo: null
});

export default function(state = DEFAULT_STATE) {
    return state;
}
